<template>
  <CafeteriaDeliveriesForm :typeEndPoint="'cafeteriaDeliveriesForm'" :dataParams="{}"/>
</template>
<script>
import CafeteriaDeliveriesForm from '@/components/modules/cafeteria/deliveries/form'
export default {
  name: 'CafeteriaDeliveriesCreate',
  components: {
    CafeteriaDeliveriesForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/cafeteria/deliveries/create.vue